<template>
  <div v-if="cur_list.name !== undefined" class="device-group__custom">

    <div class="device-group__custom-info">
      <div class="header">
        <fg-input
          v-model="cur_list.name"
          class="name"
          type="text"
          placeholder="name group"
          :label="translate('custom.name')"
        />
        <button
          class="mdi mdi-content-save btn btn-success"
          @click.prevent="save_custom_device_list"
          :disabled="check_change"
        >
          <b>{{translate('save')}}</b>
        </button>

      </div>

      <div class="main_block">
        <div class="form-group w100">
          <label>{{ translate('custom.descr') }}</label>
          <textarea
            v-model="cur_list.description"
            rows="3"
            class="form-control border-input"
            :placeholder="translate('custom.descr')"
          />
        </div>
        <fg-input
          v-model="created_at"
          class="w50"
          type="text"
          :label="translate('custom.created')"
          :placeholder="translate('custom.created')"
          :readonly="true"
        />
        <fg-input
          v-model="updated_at"
          class="w50"
          type="text"
          :label="translate('custom.updated')"
          :placeholder="translate('custom.updated')"
          :readonly="true"
        />

        <div class="response_table">
          <div class="table_header">
            <label class="title">{{ translate('custom.list') }}</label>
            <span>
              {{ '('+ translate('custom.total') +': '+ count_device + ', '+translate('custom.online')+': ' + count_online_device + ')'}}
            </span>
          </div>
          <table v-if="cur_list.devices.length > 0">
            <thead style="flex: 0">
              <tr>
                <th scope="col" class="status">
                  Status
                </th>
                <th scope="col">
                  {{ 'ID / ' + translate('device.name') }}
                </th>
                <th scope="col">
                  Device Group
                </th>
                <th scope="col" class="delete" />
              </tr>
            </thead>
            <tbody>

              <tr v-for="(device, index) in cur_list.devices" :key="index">

                <td :data-label="translate('status')" class="status" >
                  <sis-icon-status :status="device.status" />
                </td>

                <td :data-label="translate('device.name')">
                  <router-link :to="{path: '/device/' + device.fid}" class="link">
                    <span v-html="device_name(device)"/>
                  </router-link>
                </td>

                <td :data-label="translate('group.name')">
                  <router-link :to="{path: '/device_group/' + device.group?.id}" class="link">
                    <span>  {{ device.group?.name}} </span>
                  </router-link>
                </td>

                <td class="delete">
                  <span class="mdi mdi-close-box red" @click="delete_device(device)" title="delete"/>
                </td>

              </tr>

            </tbody>
          </table>

          <div v-else style="height: 100%">
            <h5 style="text-align: center" >
              {{translate('no_data')}}
            </h5>
          </div>
        </div>

        <!-- <button class="btn btn-success btn-fill" @click.prevent="open_modal_config()">
          {{ translate('device.config.open_group_config') }}
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import SisIconStatus from 'components/UIComponents/Icon/SisIconStatus.vue'

export default {
  name: 'CustomDeviceListInfo',
  props: ['group'],
  components: {
    SisIconStatus
  },
  data () {
    return {
      origin_list: {},
      cur_list: {},
    }
  },
  computed: {
    created_at(){
      return this.get_date(this.cur_list.created_at+1) // добавление 1 т.к. на тестовых данных 0, а 0 get_date не выводит
    },
    updated_at(){
      return this.get_date(this.cur_list.updated_at+1) // добавление 1 т.к. на тестовых данных 0, а 0 get_date не выводит
    },
    mobile_version(){
      return document.body.clientWidth < 768
    },
    check_change(){
      return (JSON.stringify(this.origin_list) === JSON.stringify(this.cur_list))
    },
    count_device(){
      return this.cur_list.devices.length
    },
    count_online_device(){
      let cnt = 0
      for (let device of this.cur_list.devices) {
        if (device.status === 1){
          cnt++
        }
      }
      return cnt
    }
  },
  watch: {
    group () {
      if (Object.keys(this.group).length > 0){
        this.get_dev_info()
      }else{
        this.cur_list = {}
        this.origin_list = {}
      }
    }
  },
  methods: {
    get_dev_info(){
      if (+this.group.id > 0){
        this.$http.v1.getInfoCustomDeviceList(this.group.id, (response) => {
          this.cur_list = {...response.data}
          this.origin_list = {...response.data}
        })
      }
    },
    delete_device(device){
      this.$http.v1.removeDeviceCustomDeviceList(this.group.id, device.id , (response) => {
        if (response.data) {
          this.$store.dispatch('customListUpdate')
          this.$emit('update')
          this.get_dev_info()
          this.global_notify('info', this.translate('custom.remove_device_success'))
        }else{
          this.global_notify('danger', this.translate('custom.remove_device_error'))
        }
      })
    },
    device_name (device) {
      let name = "ID: " + device.fid +'<br>'+ device.name2
      if (this.$store.getters.getPermissions.permissionGod) {
        name += '<br>' + device.name
      }
      return name
    },
    save_custom_device_list () {
      let sended_list = {...this.cur_list}
      if (sended_list.devices){
        let devices = []
        for (let device of this.cur_list.devices) {
          devices.push(device?.id)
        }
        sended_list.devices = devices
      }
      this.$http.v1.editCustomDeviceList(this.cur_list.id, {...sended_list},() => {
        this.global_notify('info', this.translate('custom.add_list_success'))
        this.$emit('update')
        this.$store.dispatch('customListUpdate')
      })
    },
  }
}
</script>

<style lang='scss' scoped>
  .device-group{
    &__custom{
      display: flex;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      padding: 10px;
      &-info{
        margin-bottom: 10px;
        height: 100%;
        .header{
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          flex-wrap: wrap;
          margin-bottom: 10px;
          height: 8%;
          .name{
            width: 50%;
            margin-bottom: 0;
          }
          .btn{
            padding: 7px;
            height: 40px;
            width: 24%;
          }
        }
        .main_block{
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          flex-wrap: wrap;
          opacity: 1;
          transition: 0.3s;
          padding: 5px 0;
          height: 91.5%;
          &.-hide{
            height: 0;
            opacity: 0;
          }
          .form-group{
            padding: 2px;
            margin-bottom: 10px;
            &.w50{
              width: 50%;
            }
            &.w100{
              width: 100%;
            }
          }
          .btn{
            width: 100%;
          }
          .response_table{
            padding: 0;
            height: 70%;
            margin-top: auto;
            .table_header{
              height: 5%;
              .title{
                margin-bottom: 10px;
                margin-right: 5px;
              }
              span{
                font-size: 12px;
              }
            }
            table{
              height: 95%;
            }
            th.delete{
              width: 50px;
            }
            td.delete{
              width: 50px;
              cursor: pointer;
              .red{
                color: #EB5E28;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width:1560px) {
    .device-group{
      &__custom{
        &-info{
          .header{
            height: auto;
            .name{
              width: 100%;
              margin-bottom: 10px;
            }
            .btn{
              width: 100%;
            }
          }
          .main_block{
            height: 79.5%;
          }
        }
      }
    }
  }

  @media (max-width:768px) {
    .device-group{
      &__custom{
        padding: 10px 0;
        overflow: auto;
        padding-right: 10px;
        &-info{
          .header{
            .name{
              width: 70%;
              margin-bottom: 0;
            }
            .btn{
              width: 13%;
              padding: 7px;
              b{
                display: none;
              }
            }
          }
          .main_block{
            .response_table{
              margin: 0;
            }
          }
        }
      }
    }
  }
</style>
